import React from 'react';
import { FiZap } from 'react-icons/fi';

const BoostCreditsTooltip = () => {
  return (
    <div className="boost-custom-tooltip">
      <div className="tooltip-header">
        <FiZap className="zap-icon-small" />
        <strong>Get Free Boosts!</strong>
      </div>
      <p className="tooltip-body">
        Need to sell faster? A Boost bumps your listing back to the absolute top of the local feed.
      </p>
      <hr className="tooltip-divider" />
      <p className="tooltip-promo">
        <strong>Refer a friend:</strong> When they post their first ad, you get <strong>1 Boost</strong> and they get <strong>2</strong>!
      </p>
      <div className="tooltip-cta">
        WhatsApp ad photos to <a href="tel:6305066105">6305066105</a> to claim.
      </div>
    </div>
  );
};

export default BoostCreditsTooltip;